import React from 'react'
import Banner from "../../Components/Banner/TermsCondition"
import Main from "../../Components/TermsCondition/TermsCondtion"
import Scroll from "../../Components/ScrollToTop";
function TermsCondition() {
  return (
    <div>
        <Scroll/>
        <Banner/>
        <Main/>
      
    </div>
  )
}

export default TermsCondition
